<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="part01"><a id="page_1"><strong>PART ONE<br/>The Day You See Me Fall Is Not the Day I Die</strong></a></h2><a id="page_1">
<p class="image1"><img alt="images" src="images/symbol.jpg"/></p>
<p class="blockquote1"><strong>One black peasant woman fell upon her Knees with her arms outstretched like a crucifix and cried, “They say that the white man is coming to rule Haiti again. The black man is so cruel to his own, <span class="underline">let the white man come!</span>”</strong></p>
</a><p class="attribution1"><a id="page_1"><strong>—Zora Neale Hurston (1938).</strong></a><a id="page_2"></a></p><a id="page_2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?157fbc28